(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[24184],{

/***/ 24184:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Benefits; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/moveyouout/benefits/styles.module.scss
var styles_module = __webpack_require__(74444);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/moveyouout/benefits/icons/improveMaintenance.tsx


function ImproveMaintenance() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "53",
        height: "53",
        fill: "none",
        viewBox: "0 0 53 53",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "53",
                height: "53",
                fill: "#000",
                rx: "5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M27.124 17.435a12.232 12.232 0 00-9.62 4.68A12.313 12.313 0 0019.219 39.1a12.213 12.213 0 0016.978-1.146 12.306 12.306 0 003.154-8.647 12.3 12.3 0 00-3.721-8.417 12.219 12.219 0 00-8.507-3.456zM18.57 24.81a.441.441 0 01.846.188.443.443 0 11-.846-.188zm.837 9.707a.442.442 0 11-.065-.332.444.444 0 01.065.333v-.001zm7.383-14.54a.44.44 0 01.746.445.441.441 0 11-.746-.445zm.656 19.476a.44.44 0 01-.735-.456.44.44 0 01.853.138.441.441 0 01-.118.318zm4.602-4.801a.44.44 0 01-.624 0l-4.615-4.63a.442.442 0 01-.13-.314v-5.963a.443.443 0 01.442-.456.44.44 0 01.441.456v5.78l4.486 4.5a.443.443 0 010 .627zm3.357.2a.44.44 0 01-.573-.388.442.442 0 01.87-.135.443.443 0 01-.297.524zm.3-9.773a.443.443 0 01-.523.342.442.442 0 11.34-.798c.147.101.219.281.182.457zM15.56 19.45l-.947.95a.944.944 0 01-1.582-.425.95.95 0 01.245-.916l3.232-3.243a.943.943 0 011.582.425.952.952 0 01-.245.916l-.947.951 1.283 1.288a14.016 14.016 0 00-1.337 1.342l-1.284-1.288zm6.943-7.502a.95.95 0 01.945-.948h7.307a.944.944 0 01.964.949.95.95 0 01-.963.948h-1.002v3.4c-.623-.122-1.255-.2-1.89-.234v-3.166H26.34v3.168c-.635.036-1.267.115-1.89.239v-3.407h-1.002a.944.944 0 01-.945-.949zm17.953 6.957a2.562 2.562 0 01-.752 1.822l-1.304 1.31a13.713 13.713 0 00-1.18-1.5l1.147-1.152a.68.68 0 00-.477-1.164.676.676 0 00-.48.203l-1.147 1.152c-.47-.429-.97-.824-1.495-1.184l1.306-1.31a2.564 2.564 0 013.628.002c.481.482.752 1.137.753 1.82l.001.002z"
            })
        ]
    });
}
/* harmony default export */ var improveMaintenance = (ImproveMaintenance);

;// CONCATENATED MODULE: ./src/components/moveyouout/benefits/icons/driveSafety.tsx


function DriveSafety() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "53",
        height: "53",
        fill: "none",
        viewBox: "0 0 53 53",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "53",
                height: "53",
                fill: "#000",
                rx: "5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M36.848 14.416C34.688 12.15 31.678 11 27.893 11h-.133c-5.721.041-11.504 3.3-11.486 9.45v4.202l-3.204 4.167a.328.328 0 00-.054.303.35.35 0 00.216.224l3.078 1.102c.09.6.241 1.654.389 2.673a.495.495 0 00.144 0c.072-.007.133-.045.259-.141.209-.176.486-.286.724-.283.237.004.547.131.724.324.093.096.15.145.237.145.108 0 .177-.076.26-.162.356-.379.968-.41 1.368-.07.025.022.079.073.104.094.191.155.339.134.519-.045.14-.141.317-.237.518-.286.537-.11.89.234 1.177.565a.333.333 0 01-.046.482.372.372 0 01-.508-.044c-.212-.242-.306-.338-.436-.338-.111 0-.169.055-.248.134a1.146 1.146 0 01-.756.32c-.249 0-.512-.12-.703-.296-.122-.113-.183-.155-.273-.155-.101 0-.159.052-.249.142-.198.196-.479.32-.709.324-.234.003-.558-.114-.727-.3-.065-.062-.151-.158-.252-.162-.123-.003-.195.069-.27.148-.188.169-.472.29-.681.296h-.076c.166 1.12.3 2.067.303 2.067.021.148.14.268.295.293 1.71.282 4.785.179 5.844.13.072 1.585.115 3.789.093 4.784a.346.346 0 00.267.345c1.703.382 3.446.572 5.192.568a36.46 36.46 0 005.574-.551.345.345 0 00.291-.345c-.035-1.116-.302-6.998-.302-6.998.828-.689 5.005-4.522 5.577-9.915.3-2.859-.352-6.902-3.085-9.775zm-12.714 9.327a.638.638 0 01-.652-.623c0-.345.292-.624.652-.624.36 0 .651.279.651.623a.638.638 0 01-.651.624zm.277-1.787h-.54l-.644-5.166a.303.303 0 01.27-.341c.014-.004.029-.004.043-.004h1.188a.307.307 0 01.317.296c0 .018 0 .032-.004.049l-.63 5.166zm3.723 1.787a.638.638 0 01-.652-.623c0-.345.292-.624.652-.624.36 0 .652.279.652.623a.638.638 0 01-.652.624zm.274-1.787h-.54l-.649-5.156a.302.302 0 01.263-.341c.018-.003.033-.003.05-.003h1.19a.31.31 0 01.316.303c0 .014 0 .027-.003.041l-.627 5.156zm3.636 1.787a.638.638 0 01-.652-.623c0-.345.292-.624.652-.624.36 0 .652.279.652.623a.638.638 0 01-.652.624zm.274-1.787h-.54l-.641-5.166a.302.302 0 01.263-.341c.018-.004.032-.004.05-.004h1.189a.31.31 0 01.317.303c0 .014 0 .028-.004.042l-.634 5.166z"
            })
        ]
    });
}
/* harmony default export */ var driveSafety = (DriveSafety);

;// CONCATENATED MODULE: ./src/components/moveyouout/benefits/icons/lowerFuelConsumption.tsx


function LowerFuelConsumption() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "53",
        height: "53",
        fill: "none",
        viewBox: "0 0 53 53",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "53",
                height: "53",
                fill: "#000",
                rx: "5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M37.717 16.45c-3.619-.294-7.007-1.828-9.572-4.373l-.658-.685A1.399 1.399 0 0026.5 11c-.362 0-.724.13-.987.392l-.658.685c-2.566 2.545-5.954 4.079-9.572 4.372-.724.066-1.283.653-1.283 1.371v3.948c0 8.289 4.54 15.99 11.81 20.069.196.13.46.163.69.163.23 0 .46-.065.69-.163C34.46 37.757 39 30.057 39 21.768V17.82c0-.718-.56-1.305-1.283-1.37zm-5.197 7.407l-6.152 6.624a1.631 1.631 0 01-.987.457h-.032a1.4 1.4 0 01-.987-.392l-3.454-3.491a1.371 1.371 0 010-1.926 1.398 1.398 0 011.94 0l2.468 2.448 5.164-5.58a1.4 1.4 0 011.94-.098c.56.522.593 1.403.1 1.958z"
            })
        ]
    });
}
/* harmony default export */ var lowerFuelConsumption = (LowerFuelConsumption);

;// CONCATENATED MODULE: ./src/components/moveyouout/benefits/icons/updateInsight.tsx


function UpdateInsight() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "53",
        height: "53",
        fill: "none",
        viewBox: "0 0 53 53",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "53",
                height: "53",
                fill: "#000",
                rx: "5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                fillRule: "evenodd",
                d: "M16.704 14h19.592A2.712 2.712 0 0139 16.704v19.592A2.712 2.712 0 0136.296 39H16.704A2.712 2.712 0 0114 36.296V16.704A2.712 2.712 0 0116.704 14zm14.56 9.444c1.169 1.432-1.008 3.21-2.178 1.779l-1.178-1.442v9.145c0 1.853-2.816 1.853-2.816 0V24.04l-1.174 1.444c-1.166 1.436-3.35-.337-2.183-1.773l3.604-4.434c.608-.747 1.822-.852 2.567.06l3.357 4.108z",
                clipRule: "evenodd"
            })
        ]
    });
}
/* harmony default export */ var updateInsight = (UpdateInsight);

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/components/moveyouout/benefits/index.tsx








const benefitsList = [
    {
        title: "No Stress",
        description: "Renting a truck can be challenging, especially in determining the right size to fit all your furniture and belongings.",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(driveSafety, {})
    },
    {
        title: "Easy Packing",
        description: "Professional movers expertly select appropriate packaging for different items and label each package for easy content identification.",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(improveMaintenance, {})
    },
    {
        title: "Injury-Free",
        description: "Arrive at your new home without frustration or physical discomfort as the entire move is handled for you.",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(lowerFuelConsumption, {})
    },
    {
        title: "Quick & Efficient",
        description: "If you need a quick move, certain companies specialize in fast, efficient relocation services to meet tight deadlines, ensuring both speed and quality.",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(updateInsight, {})
    }, 
];
function Benefits() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: `flex flex-col xl:flex-row flex-nowrap items-center justify-between mb-12 max-w-7xl px-4 mx-auto ${(styles_module_default()).DoYouKnowWrapper}`,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "w-full md:w-3/5 ",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: ` font-bold mb-8 text-3xl xl:text-4xl pt-11 md:pt-24 mb-12 ${(styles_module_default()).title}`,
                        children: "The Advantages of Hiring a Top-Rated Moving Company"
                    }),
                    benefitsList.map((benefit)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: `flex items-start mb-5`,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: `w-16 mr-8`,
                                        children: benefit.icon
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: `font-bold  text-base xl:text-lg ${(styles_module_default()).title2}`,
                                                children: benefit.title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: `text-sm mb-6 ${(styles_module_default()).brief}`,
                                                children: benefit.description
                                            })
                                        ]
                                    })
                                ]
                            })
                        }, benefit.title))
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative z-10 w-[230px] h-[216px] lg:w-[460px] lg:h-[432px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: "/moveyouout/assets/images/moving.png",
                    alt: "Benefits of Fleet Tracking",
                    layout: "fill"
                })
            })
        ]
    });
}


/***/ }),

/***/ 74444:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#16556d","lightPrimaryColor":"#dff5f9","whyUsItemTitle":"#005670","offerCallNumber":"#006336","slogan":"#018484","progressColor":"#1c75bc","linkColorDefault":"#018484","buttonBgColorDefault":"#01847f","whyUsBackgroundColor":"#005c58","whyUsColor":"#fff","melon":"#fe895c","darkSeaGreen":"#0e7d3f","marigold":"#ffcb03","fadedRed":"#cd2f32","dodgerBlue":"#4f85ff","pinkishGrey":"#bfbfbf","sea":"#329eaa","softBlue":"#6b67e9","slightlyBlack":"#161616","tealGreen":"#83b855","greyish":"#b3b3b3","paleGrey":"#f8f9fa","navy":"#011d41","pagePaddingX":"1rem","autumnGlory":"#3ea636","blackLead":"#464c4d","primary":"#b91c45","shiningSilver":"#c8c8c8","bleachedSilk":"#f3f2f2","blackBeauty":"#28252b","battleshipGrey":"#6d7577","winterSolstice":"#47525d","puritanGrey":"#a8aeaf","nero":"#242626","direWolf":"#272828","placeboBlue":"#ebf4fd","chiGong":"#ff1919","mississippiRiver":"#386189","spiroDiscoBall":"#0ac5ff","linkColor":"#565656","gray":"#eaeaea","grayBg":"#fafafa","graydark":"#b3b3b3","grayLight":"#ececec","orange":"#faa931","orangeDark":"#ff700e","orangeLight":"#f1c19c","orangePopup":"#f7951e","Blue":"#5dbbfe","blueDark":"#1b4874","green":"#0a6938","red":"#f85650","redLight":"#fff5f3","cyan":"#37c8e3","blueAster":"#266199","assault":"#184070","lucea":"#79b4e2","distantHorizon":"#f4f9fa","yellow":"#fff9e7","lynxScreenBlue":"#27aae1","singingBlue":"#0375a3","citrusSplash":"#ffc600","youngNight":"#232323","offerBorderColor":"#e4e7eb","defaultButtonColor":"#00b2b8","defaultProgressColor":"#838282","poseidon":"#143a56","vitamin":"#f90","queenOfTheNight":"#275376","trolleyGrey":"#818181","shadowMountain":"#585858","lcPrimary":"#00203f","lcSecondary":"#fdfdfd","lcLightPrimary":"#bf0a2f","lcHover":"#eef7ff","lcLink":"#ff9a03","lcButton":"#bf0a2f","lcProgress":"#9e9d9e","whyUsTitle":"#2e2e2e","whyUsItemBrief":"#747474","headerPhoneColor":"#dd6453","headerCallCenter":"#129188","goGoGreen":"#008a7b","bankVault":"#747474","secondary":"#444b53","progress":"#e489a2","hover":"#b31c1a","blue":"#0d4085","pink":"#f59aac","hoverBg":"#fef8fb","greyLight":"#f3f3f3","darkGreen":"#00a259","greenButton":"#00a259","purple":"#51378e","orangeHover":"#f1dfd0","grey":"#777","darkRed":"#ae332f","stickBtnBgColor":"#f89a1c","stickBtnBorderColor":"#f89a1c","blueLight":"#e9f9ff","carnival":"#ff9800","nickel":"#2f6177","footerColor":"#2f6177","button":"#fff2f1","darkBlue":"#222e59","lightGreen":"#d3e0c9","purpleLight":"#f6f1ff","purpleDark":"#674998","progressBarColor":"#b0b0b0","sloganColor":"#515151","phoneNumberColor":"#0d7166","popupMainColor":"#4d7ea6","stickTitleColor":"#000","stickBtnTxtColor":"#fff","progressbar":"#9a9a9a","mainColor":"#0071ac","whyUs":"#316767","secondaryColor":"#f2f4ea","tepezzaGrey":"#7d7d7d","paragraphColor":"#232323","iconColor":"#e05d26","whyUsBriefColor":"#747474","gorseYellowOrange":"#ff9800","denimBlue":"#2f6177","DoYouKnowWrapper":"styles_DoYouKnowWrapper__yRp7M","brief":"styles_brief__O8CTi","title2":"styles_title2__TlNI2"};

/***/ })

}]);